import React from 'react';
import Modal from 'react-responsive-modal';
 
export default class ModalLoader extends React.Component {
  
  render() {
    const bg = {
      modal: {
        background: "transparent",
        boxShadow: "none"
      },
      closeIcon: {
        display: "none"
      },
      overlay: {
        background: "#FFF"
      }
    };

    return (
      <div>
        <Modal open={this.props.openModal} center styles={bg} >
          <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </Modal>
      </div>
    );
  }
}
 
